export const STATEMENTS = Object.freeze({
  bergingslocaties: {
    order: 1,
    tellitURL:
      "https://tell-it-production-public.s3.eu-central-1.amazonaws.com/2e5dbb14e2a2ab1bd63b15b1/story.json",
  },
  toekomstige_alternatieven: {
    order: 2,
    tellitURL:
      "https://tell-it-production-public.s3.eu-central-1.amazonaws.com/7a4d795e49aee669811db210/story.json",
  },
  proces: {
    order: 3,
    tellitURL:
      "https://tell-it-production-public.s3.eu-central-1.amazonaws.com/86a957ed6d69478956d17286/story.json",
  },
  participatie: {
    order: 4,
    tellitURL:
      "https://tell-it-production-public.s3.eu-central-1.amazonaws.com/b93222a85d1bb72c7742f57a/story.json",
  },
});

export const STATEMENT_KEYS = Object.entries(STATEMENTS)
  .sort(([, v1], [, v2]) => v1.order - v2.order)
  .map(([k]) => k);
